import React, { useEffect, useState } from "react";
import { Modal, Typography, Box, Backdrop, Button, Paper } from '@mui/material';
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster, deleteAccountMaster } from '../../graphql/mutations';
import { LoadingButton } from "@mui/lab";
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";
import { useThemes } from "../Theme/theme";
import { useDeleteAccountMasterMutation } from "../../redux/apis/accountMaster.api";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px"
};

const DeleteSelectedLedger = ({ open, setOpen, partysData, rows, setRows, setDeleteSuccessSnakbar, setWarningSnakbar, setWarningMsg, setSelected }) => {
    const { theme } = useThemes()

    const [loading, setloading] = useState(false)
    console.log(partysData);
    const [finishedArr, setFinishedArr] = useState([])

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }

    const [deleteAccountMaster] = useDeleteAccountMasterMutation()

    async function deleteGoodsItemDet(data) {
        try {
            const res = await deleteAccountMaster({ accountsid: data })
            if (res.data) {
                if (res.data.statuscode === "Error") {
                    console.log(res.data?.statusmessage)
                    showWarningSnackbar(res.data?.statusmessage)
                    setFinishedArr(prev => ([
                        ...prev,
                        { AccountsID: data, status: false }
                    ]))
                } else {
                    setFinishedArr(prev => ([
                        ...prev,
                        { AccountsID: data, status: true }
                    ]))
                }

            } else {
                setFinishedArr(prev => ([
                    ...prev,
                    { AccountsID: data, status: false }
                ]))
            }
            setloading(false)
        } catch (error) {
            setloading(false)
            console.log(error);
        }

    }

    useEffect(() => {
        if (partysData?.length > 0) {
            if (finishedArr.length == partysData?.length) {
                // let tempPartyData = [...partysData]
                let arr = rows.filter((item, ind) => {
                    if (partysData.includes(item?.AccountsID) && finishedArr.find((e) => e.status === true && e.AccountsID === item?.AccountsID) !== undefined) {
                        console.log(item);
                    } else {
                        return item
                    }
                })
                console.log(arr, partysData, rows, finishedArr)
                setRows(arr)
                setOpen(false)
                setSelected([...partysData.filter((item) => {
                    if (finishedArr.find((e) => e.AccountsID === item && e.status === false)) {
                        return item
                    }
                })
                ])
                if (finishedArr.find((e) => e.status === false)) {
                    showWarningSnackbar("Some Parties cannot be deleted because account or invoice details have already been created for those parties !")
                } else {
                    showSuccessSnackbar("Account Deleted.")
                }
            }
        }
    }, [finishedArr])

    const deleteItem = () => {
        setloading(true)
        if (partysData?.length > 0) {
            partysData.map((item) => {
                deleteGoodsItemDet(item)
            })

        }
    }

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            <Paper sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>

                    <Typography sx={{ color: theme?.palette?.TmId.id.toString().includes("9") ? "white" : "rgb(60 60 60)", fontWeight: "bold" }}>
                        Do you want to delete this item?
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // flexDirection: { xs: 'column', sm: 'row' },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    {/* <Button onClick={handleClose} variant='outlined' sx={{flex:1,margin:'5px', fontSize : "12px"}} >No</Button> */}
                    {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}

                    <Button disabled={loading} onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                    <LoadingButton color="error" sx={{ flex: 1, margin: '5px', fontSize: "12px" }} loading={loading} disableRipple={true} variant="contained" onClick={() => deleteItem()}>
                        Yes
                    </LoadingButton>

                </Box>


            </Paper>
            {/* </Fade> */}
        </Modal>

    );
};

export default DeleteSelectedLedger;